"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyStepChangedEvent = void 0;
const event_type_1 = require("../enums/event-type");
class JourneyStepChangedEvent {
    constructor(stepType) {
        this.stepType = stepType;
        this.eventType = JourneyStepChangedEvent.EventType;
        this.timestamp = new Date();
    }
}
exports.JourneyStepChangedEvent = JourneyStepChangedEvent;
JourneyStepChangedEvent.EventType = event_type_1.EventType.JOURNEY_STEP_CHANGED_EVENT;
